import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HelperService } from '../helper/helper.service';
import { EnvironmentConfigService } from '../shared/environment-config.service';

@Injectable({
  providedIn: 'root'
})
export class CustomizeMenuService {
  // http://api.travelx.ai/api/getFoodMenuOptions?key=qw1op5cv8j0d&pid=gmr&menuid=805
  apiConfig = {
    baseUrl: 'https://api2.travelx.ai',
    // baseUrl: 'http://a.gmr.in',
    path: '/api/getFoodMenuOptions'
  };
  apiParams: any;

  constructor(private httpClient: HttpClient, private helperService: HelperService, private envService: EnvironmentConfigService) {
    this.initApiParams();
  }

  public get menuCustomizeServiceApi(): string {
    let finalRequestParams = { ...this.envService.getDefaultApiParams(), ...this.apiParams };
    // tslint:disable-next-line: max-line-length
    return this.menuCustomizeServiceApi = `${this.envService.getFoodMenuOptionsApi()}?${this.helperService.serializeToGetParams(finalRequestParams)}`;
  }
  public set menuCustomizeServiceApi(value: string) {
  }

  initApiParams() {
    this.apiParams = {
      menuid: 0
    };
  }

  getOptionList(menuId) {
    this.apiParams.menuid = menuId;
    return this.httpClient.get<any>(this.menuCustomizeServiceApi);
  }

}
